import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface BadgeProps {
  children: ReactNode
  variant?: 'default' | 'gold' | 'success' | 'warning'
  className?: string
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  const variants = {
    default: 'bg-midnight-800/60 border-slate-700/40 text-slate-300',
    gold: 'bg-gold-500/10 border-gold-500/30 text-gold-400',
    success: 'bg-profit-500/10 border-profit-500/30 text-profit-400',
    warning: 'bg-loss-500/10 border-loss-500/30 text-loss-400',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 px-4 py-2 border rounded-full text-sm font-medium',
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  )
}
